import { render, staticRenderFns } from "./IssueTypes.vue?vue&type=template&id=008a5d3a&scoped=true&"
import script from "./IssueTypes.vue?vue&type=script&lang=js&"
export * from "./IssueTypes.vue?vue&type=script&lang=js&"
import style0 from "./IssueTypes.vue?vue&type=style&index=0&id=008a5d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a5d3a",
  null
  
)

export default component.exports